import { ZIP_CODE_PATTERN_BY_COUNTRY } from "@config/consts";

import { AVAILABLE_COUNTRIES } from "@typings/globals";

export const getZipCodePattern = (
  country: AVAILABLE_COUNTRIES,
): RegExp | null => ZIP_CODE_PATTERN_BY_COUNTRY[country] || null;
